import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter, HostListener, TemplateRef, ViewChild, OnChanges } from '@angular/core';
import { ControlContainer, NG_VALUE_ACCESSOR, NgForm, FormControl } from '@angular/forms';
import { ValueAccessorHelper } from '@helpers/value-accessor-helper';
//import { ThemePalette } from '@angular/material';
import { MatAutocompleteModule } from '@angular/material/autocomplete';

@Component({
  selector: 'app-custom-autocomplete',
  templateUrl: './custom-autocomplete.component.html',
  styleUrls: ['./custom-autocomplete.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }],
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: CustomAutoCompleteComponent, multi: true }
  ],
})

export class CustomAutoCompleteComponent extends ValueAccessorHelper<any> implements OnInit, OnChanges {
  @Input() name: string;
  @Input() disabled: boolean = false;
  @Input() isRequired: boolean = false;
  @Input() errorText: string;
  @Input() label: string;
  @Input() multiSelectItems: Array<any> = [];
  @Input() autocomplete: string = 'off';
  @Input() formSubmitted: boolean = false;
  @Input() placeHolder: string = 'Select';
  // selected text display in dropdown whe choose drop down data.
  @Input() public displayName;

  // "ngModel" property binding when choose the dropdown data.
  @Input() public ngModelValue;

  @Input() parentName: string = null;
  @Input() parentId: number = 0;
  @Input() isState: boolean = false;
  @Input() stateId: number = 0;
  @Input() isSelected: boolean = true;

  public filteredOptions = [];

  private opt: Array<any>;
  @Input() set options(opt: any) {   
    this.opt = opt;

    let result = opt ? opt.length > 50 ? opt.slice(0, 10) : opt : [];

    this.filteredOptions = result;   
  }
  get options() {
    return this.opt && this.opt.length > 0 ? this.opt : [];
  }

  // tslint:disable-next-line:variable-name
  private _isLoading: boolean;
  @Input() set isLoading(opt: boolean) {
    this._isLoading = opt;
  }

  constructor(private cdf: ChangeDetectorRef) {
    super();
  }

  ngOnChanges() {
    this.cdf.detectChanges();
    if (this.isState == true && this.stateId > 0) {      
    } 
    if (this.parentName != null && this.parentId > 0) {
      let result = this.opt?.filter(op => (op[this.parentName] && op[this.parentName] == this.parentId));     
      this.filteredOptions = result ? result.length > 50 ? result.slice(0, 10) : result : [];
    }
  }

  @Output() public optionSelected: EventEmitter<any> = new EventEmitter();
  @ViewChild('defaultOptions', { static: false }) defaultOptionsRef: TemplateRef<any>;

  get isLoading(): boolean {
    return this._isLoading;
  }
 

  ngOnInit() {
    this.cdf.detectChanges();
  }

  displayFn(value): string {
    if (this.options) {
      const item = this.options.find(opt => value && opt[this.ngModelValue].toString() === value.toString());
      return item ? item[this.displayName] : '';
    }
  }

  onChangeNgModel(value) {
    this.filteredOptions = this.filterItems(value);
    this.isSelected = false;
    this.optionSelected.emit(value);
  }

  filterItems(value): Array<any> {
    value = value ? value.toLowerCase() : null;
    var result = this.options.filter(op => !value
      || (op[this.displayName] && op[this.displayName].toLowerCase().includes(value))).slice(0, 10);

    return result;
  }

  filterExactItems(value): Array<any> {
    value = value ? value.toLowerCase() : null;
    var result = this.options.filter(op => !value
      || (op[this.displayName] && op[this.displayName].toLowerCase() == value));

    return result;
  }

  onSelectionChange(event) {
    const value = event.option.value;
    const items = this.filterExactItems(value);
    const item = items && items.length > 0 ? items[0] : null;
    this.isSelected = true;
    this.optionSelected.emit(item);
  }
}
